import React from "react";
import { COLORS } from "../../../services/Constant";

function SingleLight({ light, scale }) {
  const GAP = 0.1;

  return (
    <div
      style={{
        position: "absolute",
        left: (+light.left + GAP / 2) * scale,
        top: (+light.top + GAP / 2) * scale,
        width: (+light.width - GAP) * scale,
        height: (+light.height - GAP) * scale,
        background: COLORS[light.outputColor],
        transform: `rotate(${light.angle}deg)`,
      }}
    />
  );
}

export default SingleLight;
